<p-drawer [(visible)]="visible" position="right" header="Aide" styleClass="aide-panneau" [blockScroll]="false">
  @if (aide.etat() === 'indisponible') {
    <p class="aide-panneau__indisponible" role="status">
      L'aide est momentanément indisponible. Réessayez dans quelques minutes.
    </p>
  } @else if (etatArticle() !== 'pret' || article()) {
    <div class="aide-panneau__barre">
      <button pButton type="button" class="p-button-text p-button-sm" icon="fa-light fa-arrow-left" label="Retour" (click)="retour()"></button>
      @if (!simple()) {
        <button pButton type="button" class="p-button-text p-button-sm" icon="fa-light fa-up-right-and-down-left-from-center" label="Ouvrir en grand" (click)="ouvrirEnGrand()"></button>
      }
    </div>

    @if (etatArticle() === 'chargement') {
      <p-skeleton height="1.75rem" styleClass="mb-3" />
      <p-skeleton height="12rem" />
    } @else if (etatArticle() === 'introuvable') {
      <p class="aide-panneau__indisponible">Ce tuto n'est pas disponible pour votre espace.</p>
    } @else if (etatArticle() === 'indisponible') {
      <p class="aide-panneau__indisponible" role="status">L'aide est momentanément indisponible. Réessayez dans quelques minutes.</p>
    } @else if (article()) {
      @let a = article()!;
      <h2 class="aide-panneau__titre">{{ a.titre }}</h2>
      <p class="aide-panneau__duree"><i class="fa-light fa-clock"></i> {{ a.duree }} de lecture</p>
      <app-aide-contenu [html]="a.html" (lien)="afficher($event)" (ecran)="allerA($event)" />
      <app-aide-avis [slug]="a.slug" />
      @if (a.suivant.length) {
        <h3 class="aide-panneau__sous-titre">Et ensuite ?</h3>
        <ul class="aide-panneau__liste">
          @for (s of a.suivant; track s.slug) {
            <li><button type="button" class="aide-panneau__lien" (click)="afficher(s.slug)">{{ s.titre }}</button></li>
          }
        </ul>
      }
    }
  } @else {
    @if (tour() && !simple()) {
      <button pButton type="button" class="p-button-outlined p-button-sm w-full mb-3" icon="fa-light fa-route" label="Visite guidée de cet écran" (click)="lancerVisite()"></button>
    }

    <app-aide-recherche (choisir)="afficher($event)" />

    @if (aide.etat() === 'chargement') {
      <p-skeleton height="8rem" styleClass="mt-3" />
    } @else if (rubrique()) {
      @let r = rubrique()!;
      <h3 class="aide-panneau__sous-titre"><i [class]="r.icone"></i> {{ r.titre }}</h3>
      <ul class="aide-panneau__liste">
        @for (e of r.articles; track e.slug) {
          <li>
            <button type="button" class="aide-panneau__lien" (click)="afficher(e.slug)">{{ e.titre }}</button>
            <span class="aide-panneau__muet">{{ e.duree }}</span>
          </li>
        }
      </ul>
    }

    @if (!simple()) {
      <button pButton type="button" class="p-button-text p-button-sm mt-3" icon="fa-light fa-book-open" label="Tout le centre d'aide" (click)="ouvrirEnGrand()"></button>
      @if (!tour()) {
        <button pButton type="button" class="p-button-text p-button-sm" icon="fa-light fa-route" label="Visite guidée de MONICASE" (click)="lancerVisite()"></button>
      }
    } @else {
      @for (r of aide.sommaire()?.rubriques ?? []; track r.cle) {
        @if (r.cle !== rubrique()?.cle) {
          <h3 class="aide-panneau__sous-titre"><i [class]="r.icone"></i> {{ r.titre }}</h3>
          <ul class="aide-panneau__liste">
            @for (e of r.articles; track e.slug) {
              <li><button type="button" class="aide-panneau__lien" (click)="afficher(e.slug)">{{ e.titre }}</button></li>
            }
          </ul>
        }
      }
    }
  }
</p-drawer>
